// extracted by mini-css-extract-plugin
module.exports = {"heading":"ChartHeading_heading__WQj5A","text":"ChartHeading_text__6Fe5_"};